{
  /* --HEADER STARTS HERE-- */
}
import profile from '../assets/Images/Icon_Profile.png';
import circle from '../assets/Images/circle.svg';
import badge1 from '../assets/Images/header_badge1.png';
import badge2 from '../assets/Images/header_badge2.png';
import badge3 from '../assets/Images/header_badge3.png';
import badge4 from '../assets/Images/header_badge4.png';
import badge5 from '../assets/Images/header_badge5.webp';
import badge6 from '../assets/Images/header_badge6.webp';
{
  /* --HEADER ENDS HERE-- */
}
{
  /* --ABOUT STARTS HERE-- */
}
import aboutgame from '../assets/Images/About_Game.png';
import aboutmobile from '../assets/Images/About_Mobile.png';
import aboutweb from '../assets/Images/About_Web.png';
import aboutsoftware from '../assets/Images/About_Software.png';
{
  /* -- ABOUT ENDS HERE --*/
}
{
  /* -- WORK STARTS HERE-- */
}
{
  /* -- WORK ENDS HERE --*/
}
{
  /* -- SKILLS STARTS HERE-- */
}
import skills_nextjs from '../assets/Images/Code_Skills_Nextjs.png';
import skills_api from '../assets/Images/Code_Skills_Api.png';
import skills_cpp from '../assets/Images/Code_Skills_Cpp.png';
import skills_css from '../assets/Images/Code_Skills_Css.png';
import skills_figma from '../assets/Images/Code_Skills_Figma.png';
import skills_flutter from '../assets/Images/Code_Skills_Flutter.png';
import skills_git from '../assets/Images/Code_Skills_Git.png';
import skills_graphql from '../assets/Images/Code_Skills_Graphql.png';
import skills_html from '../assets/Images/Code_Skills_Html.png';
import skills_javascript from '../assets/Images/Code_Skills_Js.png';
import skills_mu5 from '../assets/Images/Code_Skills_Mu5.png';
import skills_node from '../assets/Images/Code_Skills_Node.png';
import skills_python from '../assets/Images/Code_Skills_Python.png';
import skills_react from '../assets/Images/Code_Skills_React.png';
import skills_redux from '../assets/Images/Code_Skills_Redux.png';
import skills_sass from '../assets/Images/Code_Skills_Sass.png';
import skills_typescript from '../assets/Images/Code_Skills_Typescript.png';
import skills_vue from '../assets/Images/Code_Skills_Vue.png';
{
  /* -- SKILLS ENDS HERE --*/
}
{
  /* -- TESTIMONIALS STARTS HERE-- */
}
{
  /* -- TESTIMONIALS ENDS HERE-- */
}
{
  /* -- BRANDS STARTS HERE-- */
}
import brands_evolutionx from '../assets/Images/Brands_EvolutionX.png';
import brands_express from '../assets/Images/Brands_Express.png';
import brands_mongo from '../assets/Images/Brands_Mongo.png';
import brands_firebase from '../assets/Images/Brands_Firebase.png';
import brands_magisk from '../assets/Images/Brands_Magisk.png';
import brands_react from '../assets/Images/Brands_React.png';
import brands_next from '../assets/Images/Brands_Next.png';
import brands_corvus from '../assets/Images/Brands_Corvus.png';
import brands_chess from '../assets/Images/Brands_Chess.png';
import brands_sketchware from '../assets/Images/Brands_Sketchware.png';
{
  /* -- BRANDS ENDS HERE-- */
}
{
  /* --EDUCATION STARTS HERE-- */
}
{
  /* --EDUCATION STARTS HERE-- */
}
{
  /* --HACKING STARTS HERE-- */
}
import metasploit from '../assets/Images/Hacking_Skill_MetaSploit.png';
import burpsuite from '../assets/Images/Hacking_Skill_BurpSuite.png';
import acunetix from '../assets/Images/Hacking_Skill_Acunetix.png';
import reaver from '../assets/Images/Hacking_Skill_Reaver.png';
import hashcat from '../assets/Images/Hacking_Skill_HashCat.png';
import maltego from '../assets/Images/Hacking_Skill_Maltego.png';
import nmap from '../assets/Images/Hacking_Skill_Nmap.png';
import wireshark from '../assets/Images/Hacking_Skill_WireShark.png';
import invicti from '../assets/Images/Hacking_Skill_Invicti.png';
import intruder from '../assets/Images/Hacking_Skill_Intruder.png';
import nessus from '../assets/Images/Hacking_Skill_Nessus.png';
import qualys from '../assets/Images/Hacking_Skill_Qualys.png';
{
  /* --HACKING ENDS HERE-- */
}
{
  /* --STORYGAME STARTS HERE-- */
}
import chapter1 from '../assets/Images/StoryGame_the-ordinary-world.jpg';
import chapter2 from '../assets/Images/StoryGame_the-portal.jpg';
import chapter3 from '../assets/Images/StoryGame_start-btn.jpg';
import chapter4 from '../assets/Images/StoryGame_AI.jpg';
import chapter5 from '../assets/Images/StoryGame_skills.jpg';
import chapter6 from '../assets/Images/StoryGame_delve-deeper.jpg';
import chapter7 from '../assets/Images/StoryGame_allies.jpg';
import chapter8 from '../assets/Images/StoryGame_cave.jpg';
import chapter9 from '../assets/Images/StoryGame_ordeal.jpg';
import chapter10 from '../assets/Images/StoryGame_reward.jpg';
import chapter11 from '../assets/Images/StoryGame_dream.jpg';
import chapter12 from '../assets/Images/StoryGame_resurrection.jpg';
import chapter13 from '../assets/Images/StoryGame_elixir.jpg';
import chapter14 from '../assets/Images/StoryGame_epilogue.jpg';
import chapter15 from '../assets/Images/StoryGame_html.jpg';
import chapter16 from '../assets/Images/StoryGame_js.jpg';
import chapter17 from '../assets/Images/StoryGame_react.jpg';
import chapter18 from '../assets/Images/StoryGame_node.jpg';
{
  /* --STORYGAME ENDS HERE-- */
}
export default {
  /* --HEADER STARTS HERE-- */
  profile,
  circle,
  badge1,
  badge2,
  badge3,
  badge4,
  badge5,
  badge6,
  /* --HEADER ENDS HERE-- */
  /* --ABOUT STARTS HERE-- */
  aboutgame,
  aboutmobile,
  aboutsoftware,
  aboutweb,
  /* --ABOUT ENDS HERE-- */
  /* --WORK STARTS HERE-- */
  /* --WORK ENDS HERE-- */
  /* --SKILLS START HERE-- */
  skills_api,
  skills_cpp,
  skills_css,
  skills_figma,
  skills_flutter,
  skills_git,
  skills_graphql,
  skills_html,
  skills_javascript,
  skills_mu5,
  skills_nextjs,
  skills_node,
  skills_python,
  skills_react,
  skills_redux,
  skills_sass,
  skills_typescript,
  skills_vue,
  /* --SKILLS ENDS HERE-- */
  /* --TESTIMONIALS START HERE-- */
  /* --TESTIMONIALS ENDS HERE-- */
  /* --BRANDS STARTS HERE-- */
  brands_chess,
  brands_corvus,
  brands_evolutionx,
  brands_express,
  brands_firebase,
  brands_magisk,
  brands_mongo,
  brands_next,
  brands_react,
  brands_sketchware,
  /* --BRANDS ENDS HERE-- */
  /* --EDUCATION STARTS HERE-- */
  /* --EDUCATION ENDS HERE-- */
  /* --HACKING STARTS HERE */
  intruder,
  invicti,
  nessus,
  metasploit,
  burpsuite,
  reaver,
  maltego,
  nmap,
  acunetix,
  hashcat,
  wireshark,
  qualys,
  /* --HACKING ENDS HERE-- */
  /* --STORY GAME-- */
  chapter1,
  chapter2,
  chapter3,
  chapter4,
  chapter5,
  chapter6,
  chapter7,
  chapter8,
  chapter9,
  chapter10,
  chapter11,
  chapter12,
  chapter13,
  chapter14,
  chapter15,
  chapter16,
  chapter17,
  chapter18,
  /* --STORY GAME-- */
  /* --CONTACT STARTS HERE-- */
};
